module.exports = __webpack_public_path__ + "static/media/app_ita.977e483b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/include/images/app_ita.jpg
// module id = 108
// module chunks = 0